'use client'
import { useState } from 'react'
import parse from 'html-react-parser';
import tailwindConfig from '@tailwind.config'


const HtmlComponent = ({ html, dictionary, title = true }) => {
    const style = {
        color: tailwindConfig.theme.extend.colors.secondary,
    };
    const style2 = {
        color: tailwindConfig.theme.extend.colors.secondary,
        height: 120,
        overflow: 'hidden',
        z: 10
    };

    // console.log(html)

    const maxContentLength = 200; // Maximum characters to display before truncating
    const [showFullContent, setShowFullContent] = useState(true);

    const truncatedContent = html[0].slice(0, maxContentLength);
    const isContentTruncated = html[0].length > maxContentLength;

    const toggleContent = () => {
        setShowFullContent(!showFullContent);
    };

    return (
        <div className='mb-3 pb-3 '>
            {title && (
                <h2 className='text-maincolor font-semibold text-xl'>{dictionary.description}</h2>
            )}
            <div /*className='text-justify'*/>
                {!showFullContent && html !== undefined && (
                    <>
                        <div
                            style={style2}
                            className="text-xl [&_a]:underline [&_a]:underline-offset-4 [&_a]:text-maincolor [&_a:hover]:opacity-70"
                        >
                            {parse(`${html}`)}
                        </div>
                        {isContentTruncated && (
                            <div className='relative w-full flex flex-row-reverse'>
                                <div className='absolute right-0 left-0 top-[-20px] h-[20px] bg-gradient-to-b from-transparent to-light'></div>
                                <div className='w-full flex flex-row items-center'>
                                    <div className='w-full border-b-[1px]'></div>
                                    <div className='w-[200px]'>
                                        <button
                                            className="text-maincolor text-xl w-[200px] cursor-pointer border-[1px] border-maincolor rounded-md px-1 hover:bg-maincolor hover:text-light"
                                            onClick={toggleContent}
                                        >
                                            {showFullContent ? `${dictionary.readLess}` : `${dictionary.readMore}`}
                                        </button>
                                    </div>
                                    <div className='w-full border-b-[1px]'></div>
                                </div>
                            </div>
                        )}
                    </>
                )}
                {showFullContent && html !== undefined && (
                    <>
                        <div
                            style={style}
                            className="text-xl [&_a]:underline [&_a]:underline-offset-4 [&_a]:text-maincolor [&_a:hover]:opacity-70"
                        >
                            {parse(`${html}`)}
                        </div>
                        {isContentTruncated && (
                            <div className='w-full flex flex-row items-center mt-4'>
                                <div className='w-full border-b-[1px]'></div>
                                <div className='w-[200px]'>
                                    <button
                                        className="text-maincolor text-xl w-[200px] cursor-pointer border-[1px] border-maincolor rounded-md px-1 hover:bg-maincolor hover:text-light z-40"
                                        onClick={toggleContent}
                                    >
                                        {showFullContent ? `${dictionary.readLess}` : `${dictionary.readMore}`}
                                    </button>
                                </div>
                                <div className='w-full border-b-[1px]'></div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}

export default HtmlComponent